import { MapfreButtonComponent } from '../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router , RouterModule } from '@angular/router';
import { AcmicService,ModalOptions } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreModalComponent, MapfreButtonComponent],
  selector: 'app-success-modal-for-upload-doc',
  templateUrl: './success-modal-for-upload-doc.component.html',
  styleUrls: ['./success-modal-for-upload-doc.component.scss']
})
export class SuccessModalForUploadDocComponent implements OnInit {
  uploadDocModalOptions: ModalOptions;
  hideModal: boolean;
  isAcmic: boolean;
  @Input() policyId: string;
  @Output() closeSuccessModal: EventEmitter<boolean> = new EventEmitter();
  
  constructor(
    private acmicService: AcmicService,
    private router: Router
  ) { 
    this.hideModal = false;
    this.isAcmic = false;
  }
  hideModalAction(): void {
    this.hideModal = !this.hideModal;
    this.closeSuccessModal.emit(true);
    this.router.navigate(['billing', 'upload-files']);
  }

  hideOnClick(event): void {
    if (!event.target.closest(".modal-body")) {
      this.hideModalAction();
    }
  }
  gotoDocuments() {
    this.closeSuccessModal.emit(true);
    this.router.navigate(['my-insurance', this.policyId, 'documents']);
  }
  setModalOptions() {
    this.uploadDocModalOptions = new ModalOptions({
      additionalClasses: 'modal-medium modal-dialog center-on-page',
      modalId: 'successModalForUploadDoc',
      typeOfModal: 'default',
      modalName: 'success_modal_for_upload_doc',
      onLoad: true,
      animatePosition: 'top'
    }); 
  }
  ngOnInit(): void {
    this.setModalOptions();
    this.isAcmic = this.acmicService.isACMIC();
  }

}
